<template>
  <div class="top_controller">
    <div class="lv_flexalign_center step">
      <button
        type="button"
        class="step_button"
        :class="{ disabled: !revoke }"
        :disabled="!revoke"
        aria-label="撤销"
        @click.stop="revokeFunc"
      >
        <van-icon name="revoke" />
      </button>
      <span class="step_divider"></span>
      <button
        type="button"
        class="step_button"
        :class="{ disabled: !redo }"
        :disabled="!redo"
        aria-label="重做"
        @click.stop="redoFunc"
      >
        <van-icon name="replay" />
      </button>
    </div>
    <div class="angle">
      <div class="lv_flexalign_center">
        <div>X</div>
        <div>{{ rotateX }}°</div>
      </div>
      <div class="lv_flexalign_center">
        <div>Y</div>
        <div>{{ rotateY }}°</div>
      </div>
      <div class="reflash lv_flex_center" @click="reset">
        <i class="iconfont icon-shuangxiangxuanzhuan" />
        刷新
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      revoke: 0, // 后退
      redo: 0, // 前进
      rotateX: 90,
      rotateY: this.$route.path === "/studio" || this.$route.query.editorType === "studio" ? 0 : 180,
      editorType: this.$route.path === "/studio" || this.$route.query.editorType === "studio" ? "studio" : "free3d",
    };
  },
  methods: {
    revokeFunc() {
      if (!this.revoke) return;
      this.$bus.$emit("revoke");
    },
    redoFunc() {
      if (!this.redo) return;
      this.$bus.$emit("redo");
    },
    reset() {
      this.rotateX = 90;
      this.rotateY = this.editorType === "studio" ? 0 : 180;
      this.$bus.$emit("setAngle", {
        x: this.rotateX,
        y: this.rotateY,
      });
    },
  },
  created() {
    this.$bus.$on("camera-change", (e) => {
      this.rotateX = parseInt(e.rotateX);
      this.rotateY = parseInt(e.rotateY);
    });

    this.$bus.$on("step-change", (e) => {
      this.revoke = e.revoke;
      this.redo = e.redo;
    });

    this.$bus.$on("editor-type-change", (type) => {
      this.editorType = type === "studio" ? "studio" : "free3d";
      this.rotateX = 90;
      this.rotateY = this.editorType === "studio" ? 0 : 180;
    });
  },
};
</script>

<style lang="scss" scoped>
.top_controller {
  position: fixed;
  top: rem(104);
  left: rem(18);
  z-index: 80;
  .step {
    display: inline-flex;
    align-items: center;
    padding: rem(6);
    background: rgba(255, 255, 255, 0.84);
    border: 1px solid rgba(218, 226, 209, 0.9);
    border-radius: rem(28);
    box-shadow: 0 rem(6) rem(16) rgba(48, 64, 42, 0.1);

    .step_button {
      width: rem(42);
      height: rem(42);
      padding: 0;
      border: 0;
      border-radius: 50%;
      background: rgba(232, 239, 216, 0.92);
      color: #4f7c16;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: rem(26);

      &.disabled {
        background: rgba(242, 244, 238, 0.86);
        color: #aeb6a8;
        cursor: not-allowed;
      }
    }

    .step_divider {
      width: 1px;
      height: rem(24);
      background: rgba(191, 201, 178, 0.75);
      margin: 0 rem(8);
    }
  }
  .angle {
    margin-top: rem(43);
    width: rem(90);
    background: #f7f7f7;
    border-radius: rem(14);
    border: 1px solid #dcdcdc;
    padding-top: rem(15);
    box-sizing: border-box;
    > .lv_flexalign_center {
      margin-bottom: rem(13);
      > div {
        &:first-child {
          width: rem(20);
          line-height: rem(20);
          background: #d0b35e;
          color: #fff;
          text-align: center;
          font-size: rem(16);
          margin-left: rem(16);
        }
        &:last-child {
          font-size: rem(18);
          margin-left: rem(3);
        }
      }
    }
    .reflash {
      height: rem(50);
      font-size: rem(20);
      margin: 0 rem(6);

      border-top: 1px solid #cdcdcd;
      i {
        font-size: rem(16);
        margin-right: rem(5);
      }
    }
  }
}
</style>
